import React from 'react';
const IconPersonAdd = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C12.79 4 11 5.79 11 8C11 10.21 12.79 12 15 12ZM6 10V7H4V10H1V12H4V15H6V12H9V10H6ZM7 18C7 15.34 12.33 14 15 14C17.67 14 23 15.34 23 18V20H7V18Z" fill="#666666"/>
</svg>
);
};
export default IconPersonAdd;